import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import {
  CreateIntegrationConfigurationResponse,
  Integration,
  UpdateIntegrationConfigurationRequest,
} from '../../api/models';
import { getAll_2 as allIntegrations } from '../../api/fn/integration-configuration/get-all-2';
import {
  GetByOrganizationId_5$Params,
  getByOrganizationId_5 as getIntegrationbyIdFn,
} from '../../api/fn/integration-configuration/get-by-organization-id-5';
import {
  deleteIntegrationConfiguration as deleteIntegrationConfigurationFn,
  DeleteIntegrationConfiguration$Params,
} from '../../api/fn/integration-configuration/delete-integration-configuration';
import {
  Create_2$Params,
  create_2 as createIntegrationFn,
} from '../../api/fn/integration-configuration/create-2';
import { UpdateOrganizationParams } from '../../types/types';
import {
  update_2 as updateIntegrationFn,
  Update_2$Params,
} from '../../api/fn/integration-configuration/update-2';

@Injectable({ providedIn: 'root' })
export class IntegrationService {
  constructor(private apiService: ApiService) {}

  private _integrations$!: Observable<Integration[] | undefined>;

  getAlIntegrations(): Observable<Integration[] | undefined> {
    if (!this._integrations$) {
      this._integrations$ = this.apiService.invoke(allIntegrations).pipe(
        map((data) => data.integrations),
        shareReplay(1)
      );
    }
    return this._integrations$;
  }

  getIntegrationById(
    params: GetByOrganizationId_5$Params
  ): Observable<Integration | undefined> {
    return this.apiService
      .invoke(getIntegrationbyIdFn, params)
      .pipe(map((data) => data.integration));
  }

  createIntegration(
    params: Create_2$Params
  ): Observable<CreateIntegrationConfigurationResponse> {
    return this.apiService.invoke(createIntegrationFn, params);
  }

  deleteIntegration(
    params: DeleteIntegrationConfiguration$Params
  ): Observable<boolean> {
    return this.apiService
      .invoke(deleteIntegrationConfigurationFn, params)
      .pipe(
        map(() => true),
        catchError(() => {
          return of(false);
        })
      );
  }

  updateIntegration(integrationParams: UpdateOrganizationParams) {
    const updateBody: UpdateIntegrationConfigurationRequest = {
      authenticationType: integrationParams.organizationAuthType,
      organizationName: integrationParams.organizationName,
      enabled: integrationParams.organizationStatus,
      customerIds: integrationParams.organizationPartnerIds,
    };
    const params: Update_2$Params = {
      organizationId: integrationParams.organizationId,
      body: updateBody,
    };

    return this.apiService.invoke(updateIntegrationFn, params).pipe(
      map(() => true),
      catchError((error) => {
        return of(false);
      })
    );
  }
}
